import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-between" }
const _hoisted_2 = { key: 0 }

import { ref, computed } from 'vue';
import { useQuasar } from 'quasar';

// Personal components
import QCopyrightComponent from '@pages/terms/components/QCopyrightComponent.vue';
import DialogConsole from '@components/dialog/DialogConsole.vue';
import QBtnValid from '@components/form/QBtnValid.vue';

// Personal libs
import { RouteEnum } from 'src/shared/enum/route.enum';
import { SkipLinkEnum } from 'src/shared/enum/skip-link.enum';
import { IUser } from '@shared/interface/model.interface';
import { RoleEnum } from '@shared/enum/role.enum';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Globals
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutFooter',
  setup(__props) {

// Vendor
const $q = useQuasar()

/**
 * Reactive datas
 */
const showConsole = ref<boolean>(false);

/**
 * Computed properties
 */
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);
const isDeveloper = computed<boolean>(
  () => connectedUser.value?.roles?.includes(RoleEnum.ROLE_DEV) === true,
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    id: _unref(SkipLinkEnum).NAVIGATION_FOOTER,
    elevated: !_unref($q).dark.isActive,
    class: "bg-primary text-white q-pa-sm",
    role: "contentinfo",
    tabindex: "-1"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createCommentVNode(" Copyright "),
          _createVNode(QCopyrightComponent),
          _cache[6] || (_cache[6] = _createTextVNode(" - ")),
          _createCommentVNode(" Plan du site "),
          _createVNode(_component_router_link, {
            class: "router-link-white",
            to: `/${_unref(RouteEnum).SITE_MAP}`
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Plan du site")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]),
          _cache[7] || (_cache[7] = _createTextVNode(" - ")),
          _createCommentVNode(" Mentions légales "),
          _createVNode(_component_router_link, {
            class: "router-link-white",
            to: `/${_unref(RouteEnum).MENTIONS_LEGALES}`
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Mentions légales")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]),
          _cache[8] || (_cache[8] = _createTextVNode(" - ")),
          _createCommentVNode(" Conditions Générales d'Utilisation "),
          _createVNode(_component_router_link, {
            class: "router-link-white",
            to: `/${_unref(RouteEnum).CGU}`
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Conditions générales")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]),
          _cache[9] || (_cache[9] = _createTextVNode(" - ")),
          _createCommentVNode(" Déclaration d'accessibilité "),
          _createVNode(_component_router_link, {
            class: "router-link-white",
            to: `/${_unref(RouteEnum).A11Y}`
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Accessibilité : partiellement conforme")
            ])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        (isDeveloper.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(QBtnValid, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConsole.value = true)),
                "icon-left": 'analytics',
                label: 'Afficher la console'
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(DialogConsole, {
        show: showConsole.value,
        maximized: false,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showConsole.value = false))
      }, null, 8 /* PROPS */, ["show"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "elevated"]))
}
}

})